import ReactGA from "react-ga4";

const GA_MEASUREMENT_ID = "G-L3DVCZCC3G";

export const initGA = () => {
  // Initialize GA4 with disabled page view tracking (we handle it manually for SPA)
  ReactGA.initialize(GA_MEASUREMENT_ID, {
    gtagOptions: {
      send_page_view: false,
    },
  });
};

export const trackPageView = (path: string) => {
  ReactGA.send({ hitType: "pageview", page: path });
};

interface AnalyticsEvent {
  category: string;
  action: string;
  label?: string;
  value?: number;
}

export const trackEvent = ({
  category,
  action,
  label,
  value,
}: AnalyticsEvent) => {
  ReactGA.event({
    category,
    action,
    label,
    value,
  });
};

// Pre-defined categories for consistency
export const CATEGORIES = {
  TOOL: "Tool",
  FILE: "File",
  NAVIGATION: "Navigation",
  ENGAGEMENT: "Engagement",
};
